<div class="white-box">
    <h1 *ngIf="!measureWasMade">Agora, Vamos ver como está sua Pressão Arterial!</h1>
    <h1 *ngIf="measureWasMade">Tudo certo, pode continuar para o próximo medidor!</h1>
    <div class="row">
        <div class="col-md-12">
            <img class="img-fc" src="assets/images/blood-pressure.jpg" />
        </div>
        <div *ngIf="!measureWasMade" class="col-md-12">
            <h3>Siga as instruções abaixo</h3>
        </div>
        <div *ngIf="!measureWasMade" class="col-md-12">
            <p><b>1</b> - Insira o manguito(braçadeira) no braço esquerdo com a mangueira voltada para baixo.</p>
            <p><b>2</b> - Pressione o botão Start no aparelho de pressão.</p>
            <p><b>3</b> - Espere o manguito inflar(encher).</p>
            <p><b>4</b> - Aguarde o valor aparecer no visor.</p>
            <p><b>5</b> - Caso o valor medido não apareça na tela em alguns segundos, informe o valor manualmente</p>
        </div>
        <div *ngIf="measureWasMade" class="col-md-12">
            <h3>Sua Pressão Arterial é: <b>{{sistolic}}/{{diastolic}}</b>mmHg</h3>
        </div>
    </div>
    <div class="row">
        <div class="col-md-3">
            <button mat-flat-button type="button" color="primary" class=" btn-block" (click)="callChangePage(oximeter)">
                <span>Voltar</span>
            </button>
        </div>
        <div class="col-md-3">
            <button (click)="leaveMeasurer.emit()" mat-flat-button type="button" color="primary" class=" btn-block">
                <span>Sair</span>
            </button>
        </div>
        <div class="col-md-3">
            <button mat-flat-button type="button" color="primary" class=" btn-block" (click)="openManualModal()">
                <span>Informar manualmente</span>
            </button>
        </div>
        <div *ngIf="measureWasMade" class="col-md-3">
            <button mat-flat-button type="button" color="primary" class=" btn-block" (click)="callChangePage(thermometer)">
                <span>Próximo</span>
            </button>
        </div>
        <div *ngIf="!measureWasMade" class="col-md-3">
            <button mat-flat-button type="button" color="primary" class=" btn-block" (click)="callChangePage(thermometer)">
                <span>Não Informar</span>
            </button>
        </div>
    </div>
    <div class="row">
        <div class="index-page col-md-12">
            Página 2 de 4
        </div>
    </div>
</div>